
const state = {
    activeTab: "tab1",
    testString: "NULL TEST",

    searchSources: [],
    searchResults: [],
    selectedLayers: [],
    selectedSources:  [],
    selectedSourcesName: [],
    searchWidget: {},
    highlightInteriorBuilding: [],
    buildingFeatures: [],

    selectIntBldg: undefined,
    selectIntRm: undefined,
    roomNumbers: [],
    routerRoom: undefined,
    roomMessage: undefined,
    highlightSource: 'search',
    roomFloorsString: undefined
};

const getters = {
    getSearchSources: (state) => state.searchSources,
    getSearchResults: (state) => state.searchResults,
    getSelectedLayers: (state) => state.selectedLayers,
    getSelectedSources: (state) => state.selectedSources,
    getselectedSourcesName: (state) => state.selectedSourcesName,    
    getHighlightInteriorBuilding: (state) => state.highlightInteriorBuilding,
    getsearchWidget: (state) => state.searchWidget,
    getbuildingFeatures: (state) => state.buildingFeatures,

    getSelectIntBldg: (state) => state.selectIntBldg,
    getSelectIntRm: (state) => state.selectIntRm,
    getRoomNumbers: (state) => state.roomNumbers,
    getRouterRoom: (state) => state.routerRoom,
    getRoomMessage: (state) => state.roomMessage,
    getHighlightSource: (state) => state.highlightSource,
    getroomFloorsString: (state) => state.roomFloorsString,

};

const mutations = {
    SET_SRCH_SRC: (state, payload) => {
        state.searchSources = payload;
    },

    SET_SRCH_RES: (state, payload) => {
        state.searchResults = payload;
    },

    SET_SLTD_LYRS: (state, payload) => {
        state.selectedLayers.value = payload;
    },

    SET_SLTD_SRCS: (state, payload) => {
        state.selectedSources = payload;
    },

    SET_SLETD_SRCSNAMES: (state, payload) => {
        state.selectedSourcesName = payload;
    },

    SET_HLGHT_INT: (state, payload) => {
        state.highlightInteriorBuilding = payload;
    },

    SET_SRCH_WDGT: (state, payload) => {
        state.searchWidget = payload;
    },

    SET_BLDG_FEATS: (state, payload) => {
        state.buildingFeatures = payload;
    },

    // 
    SET_ACTIVE_TAB: (state, tabName) => {
        state.activeTab = tabName;
    },

    SET_INT_BLDG: (state, tabName) => {
        state.selectIntBldg = tabName;
    },

    SET_INT_RM: (state, tabName) => {
        state.selectIntRm = tabName;
    },

    SET_RM_NUM: (state, tabName) => {
        state.roomNumbers = tabName;
    },

    SET_RM_MSG: (state, tabName) => {
        state.roomMessage = tabName;
    },

    SET_HLGTSRC: (state, tabName) => {
        state.highlightSource = tabName;
    },

    SET_RMFLR_STR: (state, tabName) => {
        state.roomFloorsString = tabName;
    },
};

const actions = {
    SET_ACTIVE_TAB: ({ commit }, tabName) => {
        commit('setActiveTab', tabName);
    },


    loadRooms: ({commit}, bldgName) => {
        const items= []
        const _this= this
        // console.log("insd LR", bldgNum)
        // fetch("https://api.pdc.arizona.edu/rooms/" + bldgNum + "/")
        fetch("https://api.pdc.arizona.edu/rooms/21/")
            .then(
                function (response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }

                    // Examine the text in the response
                    response.json().then(function (data) {


                        data.forEach(element => {
                            // console.log(element)
                            let attrs = {
                                text: '',
                                value: ''
                            }

                            attrs["text"] = `${element.number}`
                            //attrs["text"] = element.number
                            if (attrs["text"][0] == "0") {
                                //if first value is 0
                                attrs["text"] = attrs["text"].substr(1);
                            }
                            attrs["value"] = element.number
                            if(element["deptName"] == "Unassignable Space" || element["deptID"] == "9956" || element["categorySuperName"] == "Nonassignable Area") {

                            } else {
                                items.push(attrs)
                            }
                        });
                        // console.log(items);
                        items.sort((a, b) => a["value"] < b["value"] ? -1 : a["value"] > b["value"] ? 1 : 0).values
                        console.log(items);
                        commit('SET_RM_NUM',items)
                        // console.log("Done loading rooms...")

                        // setTimeout(() => {
                        //     let selectRoomBtn = ((_this.$refs.selectRoom as Vue).$el as HTMLInputElement);
                        //     console.log(selectRoomBtn)
                        //     // selectRoomBtn.open();
                        //     // selectRoomBtn.focus();
                        //                  }, 3000);

                    });
                    /**/
                }
            )
            .catch(function (err) {
                console.log('Fetch Error :-S', err);
            });
    }
};


export default {
    state,
    getters,
    mutations,
    actions
};